/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Address } from '../models/Address';
import type { BatchChangeClientContactAccountStateRequest } from '../models/BatchChangeClientContactAccountStateRequest';
import type { Client } from '../models/Client';
import type { ClientConfig } from '../models/ClientConfig';
import type { ClientContactCollection } from '../models/ClientContactCollection';
import type { ClientDataType } from '../models/ClientDataType';
import type { ClientSummaryCollection } from '../models/ClientSummaryCollection';
import type { ContentUploadUrl } from '../models/ContentUploadUrl';
import type { CustomFieldDefinition } from '../models/CustomFieldDefinition';
import type { ExecutionJob } from '../models/ExecutionJob';
import type { ExternalIdentityProvider } from '../models/ExternalIdentityProvider';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ClientsService {
    /**
     * Lists clients
     * @returns ClientSummaryCollection A 200 response.
     * @throws ApiError
     */
    public static listClients({
        companyName,
        status,
        branch,
        page,
        limit,
    }: {
        /**
         * company name
         */
        companyName?: string,
        /**
         * Client status
         */
        status?: 'ACTIVE' | 'INACTIVE' | 'POTENTIAL',
        /**
         * LLTS branch
         */
        branch?: number,
        /**
         * Sets current page index
         */
        page?: number,
        /**
         * Sets the page size
         */
        limit?: number,
    }): CancelablePromise<ClientSummaryCollection> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/clients',
            query: {
                'companyName': companyName,
                'status': status,
                'branch': branch,
                'page': page,
                'limit': limit,
            },
            errors: {
                400: `bad input parameter`,
            },
        });
    }
    /**
     * Fetches a client by ID
     * @returns Client successful operation
     * @throws ApiError
     */
    public static getClient({
        clientId,
    }: {
        /**
         * ID of the client that is being fetched
         */
        clientId: string,
    }): CancelablePromise<Client> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/clients/{clientId}',
            path: {
                'clientId': clientId,
            },
            errors: {
                400: `Invalid parameters`,
                404: `Client config not found`,
            },
        });
    }
    /**
     * Fetches the business address of a given client
     * @returns Address successful operation
     * @throws ApiError
     */
    public static getClientBusinessAddress({
        clientId,
    }: {
        /**
         * ID of the client whose business address is being fetched
         */
        clientId: string,
    }): CancelablePromise<Address> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/clients/{clientId}/businessAddress',
            path: {
                'clientId': clientId,
            },
            errors: {
                400: `Invalid parameters`,
                404: `Client not found`,
            },
        });
    }
    /**
     * Fetches client contacts for a given client
     * @returns ClientContactCollection successful operation
     * @throws ApiError
     */
    public static listClientContacts({
        clientId,
    }: {
        /**
         * client ID
         */
        clientId: string,
    }): CancelablePromise<ClientContactCollection> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/clients/{clientId}/clientContacts',
            path: {
                'clientId': clientId,
            },
            errors: {
                400: `Invalid parameters`,
                404: `Client not found`,
            },
        });
    }
    /**
     * Batch enable/disable Cognito accounts for client contacts
     * @returns ExecutionJob Execution job created
     * @throws ApiError
     */
    public static batchChangeClientContactAccountState({
        clientId,
        requestBody,
    }: {
        clientId: string,
        requestBody?: BatchChangeClientContactAccountStateRequest,
    }): CancelablePromise<ExecutionJob> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/clients/{clientId}/clientContacts/actions/batchChangeAccountState',
            path: {
                'clientId': clientId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Lists custom fields definitions for a client
     * @returns CustomFieldDefinition successful operation
     * @throws ApiError
     */
    public static listCustomFieldDefinitions({
        clientId,
    }: {
        /**
         * client ID
         */
        clientId: string,
    }): CancelablePromise<Array<CustomFieldDefinition>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/clients/{clientId}/customFieldDefinitions',
            path: {
                'clientId': clientId,
            },
            errors: {
                400: `Invalid parameters`,
                404: `Client not found`,
            },
        });
    }
    /**
     * Update custom field definitions for a client
     * @returns any successful operation
     * @throws ApiError
     */
    public static updateCustomFieldDefinitions({
        clientId,
        requestBody,
    }: {
        /**
         * client ID
         */
        clientId: string,
        /**
         * updated custom fields
         */
        requestBody?: Array<CustomFieldDefinition>,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/clients/{clientId}/customFieldDefinitions',
            path: {
                'clientId': clientId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid parameters`,
            },
        });
    }
    /**
     * Creates client configuration
     * @returns any successful operation
     * @throws ApiError
     */
    public static createClientConfig({
        requestBody,
    }: {
        /**
         * New client
         */
        requestBody?: ClientConfig,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/clientConfigs',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid parameters`,
            },
        });
    }
    /**
     * Fetches client config by client ID
     * @returns ClientConfig successful operation
     * @throws ApiError
     */
    public static getClientConfig({
        id,
    }: {
        /**
         * ID of the client that is being fetched
         */
        id: string,
    }): CancelablePromise<ClientConfig> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/clientConfigs/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid parameters`,
                404: `Client config not found`,
            },
        });
    }
    /**
     * Updates client
     * @returns any successful operation
     * @throws ApiError
     */
    public static updateClientConfig({
        id,
        requestBody,
    }: {
        /**
         * client ID
         */
        id: string,
        /**
         * Updated client config
         */
        requestBody?: ClientConfig,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/clientConfigs/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid parameters`,
                404: `Client not found`,
            },
        });
    }
    /**
     * Returns a signed URL for uploading static content, such as images, to client configuration.
     * @returns ContentUploadUrl successful operation
     * @throws ApiError
     */
    public static getClientContentUploadUrl({
        id,
        dataType,
        fileName,
        mimeType,
    }: {
        /**
         * Client ID
         */
        id: string,
        /**
         * Type of the uploaded data.  Supported values: BANNER, LOGO
         */
        dataType: ClientDataType,
        /**
         * Name of the file that will be uploaded
         */
        fileName: string,
        /**
         * MIME type of the uploaded file
         */
        mimeType?: string,
    }): CancelablePromise<ContentUploadUrl> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/clientConfigs/{id}/contentUploadUrl',
            path: {
                'id': id,
            },
            query: {
                'dataType': dataType,
                'fileName': fileName,
                'mimeType': mimeType,
            },
            errors: {
                400: `Invalid parameters`,
                404: `Client config not found`,
            },
        });
    }
    /**
     * Returns Cognito identity providers associated with the client's configured email domains
     * @returns ExternalIdentityProvider successful operation
     * @throws ApiError
     */
    public static listClientExternalIdentityProviders({
        id,
    }: {
        /**
         * Client ID
         */
        id: string,
    }): CancelablePromise<Array<ExternalIdentityProvider>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/clientsConfigs/{id}/externalIdentityProviders',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid parameters`,
            },
        });
    }
    /**
     * Updates ddb client configs using xtrf data
     * @returns any successful operation
     * @throws ApiError
     */
    public static syncClientConfigWithXtrf({
        id,
    }: {
        /**
         * Client ID
         */
        id: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/clientConfigs/{id}/actions/syncWithXtrf',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid parameters`,
                404: `Client config not found`,
            },
        });
    }
    /**
     * Triggers synchronization of all client configs with XTRF
     * @returns ExecutionJob Sync execution started successfully
     * @throws ApiError
     */
    public static syncAllClientConfigsWithXtrf(): CancelablePromise<ExecutionJob> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/clientConfigs/actions/syncWithXtrf',
            errors: {
                500: `Internal server error`,
            },
        });
    }
}
